import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../redux/axios';

const initialState = {
  roles: [],
  departmentInfo: {},
  templateInfo: {},
  response: null,
  isFetching: false,
  isSuccess: false,
  isAddTemplateSuccess: false,
  isError: false,
  errorMessage: '',
};

export const editTemplate = createAsyncThunk(
  '/chd/users/edittemplate',
  async (tdata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.patch('/api/chd/template/' + tdata.uid, tdata.udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      let data = response.data;

      if (response.status === 200) {
        return data;
      }
      else if (response.status === 201) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const editTemplateSlice = createSlice({
  name: 'chdedittemplate',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    getTemplateInfo: (state, { payload }) => {
      state.templateInfo = payload.data;
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.isSuccess = true;
    },
    getRolesByUserType: (state, { payload }) => {
      state.roles = payload.data;
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.isSuccess = true;
    },
    getDepartmentInfo: (state, { payload }) => {
      state.departmentInfo = payload.data;
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.isSuccess = true;
    },
    clearStateAddUser: (state, { payload }) => {
      state.roles = [];
      state.response = null;
      state.templateInfo = {};
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
    },
    isSuccess: (state, { payload }) => {
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.isSuccess = false;
      state.isAddTemplateSuccess = false;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {
    [editTemplate.fulfilled]: (state, { payload }) => {

      state.response = payload;
      state.isFetching = false;
      state.isAddTemplateSuccess = true;
      return state;
    },
    [editTemplate.pending]: (state) => {
      state.isFetching = true;
    },
    [editTemplate.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isAddTemplateSuccess = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    }
  },
});

export const { clearStateAddUser, isSuccess, getRolesByUserType, getDepartmentInfo, getTemplateInfo } = editTemplateSlice.actions;

export const getTemplateInfoAsyn = (udata) => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  //const response = await axios.get('/api/userRoles',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

  let response = await axios({
    url: '/api/chd/template/' + udata,
    method: 'get',
    //timeout: 8000,
    headers: {
      //'Content-Type': 'application/json',
      "Authorization": `Bearer ${tokenStr}`
    }
  })

  let data = response.data;
  //console.log(data.data)
  dispatch(getTemplateInfo(data));
};

export const getRolesByUserTypeAsyn = (udata) => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  //const response = await axios.get('/api/userRoles',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

  let response = await axios({
    url: '/api/chd/userRoles/forAssigning/?userType=' + udata,
    method: 'get',
    //timeout: 8000,
    headers: {
      //'Content-Type': 'application/json',
      "Authorization": `Bearer ${tokenStr}`
    }
  })

  let data = response.data;
  //console.log(data.data)
  dispatch(getRolesByUserType(data));
};

export const getDepartmentInfoAsyn = (udata) => async (dispatch, getState) => {
  const { auth } = getState()
  let tokenStr = auth.user.token;
  //const response = await axios.get('/api/userRoles',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

  let response = await axios({
    url: '/api/chd/departments/forAssigning/Chief of Air Staff',
    method: 'get',
    //timeout: 8000,
    headers: {
      //'Content-Type': 'application/json',
      "Authorization": `Bearer ${tokenStr}`
    }
  })

  let data = response.data;
  //console.log(data.data)
  dispatch(getDepartmentInfo(data));
};


export const getApptAsyn = (dtype) => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    let response = await axios({
      url: '/api/chd/template/getAppt?department=Chief of Air Staff&code=b&departmentTypeName=' + dtype,
      method: 'get',
      //timeout: 8000,
      headers: {
        //'Content-Type': 'application/json',
        "Authorization": `Bearer ${tokenStr}`
      }
    });

    let data = response.data;
    return data;
  } catch (error) {
    return error.response.data;
  }
};

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateAddUser());
  }
}

export function clearStateSuccess() {

  return async (dispatch) => {
    dispatch(isSuccess());
  }
}

export const editTemplateSelector = (state) => state.chdedittemplate;

export default editTemplateSlice.reducer;
